import type { BasketItemModel } from '@activebrands/core-web/types/basket';
import type { Category } from '@activebrands/core-web/types/tracking-events';

export const money = (value: number) => Math.round(value * 100) / 100;
export const truncate = (value = '', max: number) => value.slice(0, max);

// Impact wants quantity × price excluding discounts, shipping and tax.
export const toSubTotal = (item: BasketItemModel) => money(item.priceEachBeforeDiscountAsNumber * item.quantity);

export const findCategoryPath = (
    categories: Category[] = [],
    targetId: string,
    path: string[] = []
): string[] | null => {
    for (const category of categories) {
        const next = [...path, category.name];

        if (String(category.id) === targetId) {
            return next;
        }

        const found = findCategoryPath(category.categories, targetId, next);

        if (found) {
            return found;
        }
    }

    return null;
};

// Category can alter payouts, so prefer the product type attribute. The category tree is
// merchandising-controlled — a CMS change would otherwise move what a partner is paid.
export const toCategory = (item: BasketItemModel) => {
    const reference = item.productReference ?? {};
    const productType = reference.customAttributes?.attrProductType?.name;

    if (productType) {
        return truncate(productType, 64);
    }

    const { canonicalCategory, categories } = reference;
    const path = canonicalCategory ? findCategoryPath(categories, String(canonicalCategory)) : null;

    return truncate(path?.[path.length - 1] ?? '', 64);
};
